// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "contentWrapper-1Pkah";
var _5 = "container_dropdown-1CZkv";
var _6 = "content-32l5i";
var _7 = "content__center-26uSN";
var _8 = "flight-DLsdw";
var _9 = "flight_thin-3YQ0A";
var _a = "segments-l2WS-";
var _b = "segments__big-2Akhe";
var _c = "segment__flightWrapper-3o1zU";
var _d = "segment__card-17yzZ";
var _e = "segment__flight-1Co3C";
var _f = "time-1sovY";
var _10 = "segment__transfer-1SiQP";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "contentWrapper", _5 as "container_dropdown", _6 as "content", _7 as "content__center", _8 as "flight", _9 as "flight_thin", _a as "segments", _b as "segments__big", _c as "segment__flightWrapper", _d as "segment__card", _e as "segment__flight", _f as "time", _10 as "segment__transfer" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "contentWrapper": _4, "container_dropdown": _5, "content": _6, "content__center": _7, "flight": _8, "flight_thin": _9, "segments": _a, "segments__big": _b, "segment__flightWrapper": _c, "segment__card": _d, "segment__flight": _e, "time": _f, "segment__transfer": _10 }
